module.exports = __webpack_public_path__ + "img/LogoSecundario.727c377c.svg";